// Groundy pictures for onboarding, used exactly as supplied.
import welcomeBody from "@/assets/onboarding/groundy/groundy-welcome-wave-body.png";
import welcomeHand from "@/assets/onboarding/groundy/groundy-welcome-wave-hand.png";
import score from "@/assets/onboarding/groundy/groundy-score.png";
import priorities from "@/assets/onboarding/groundy/groundy-priorities.png";
import tileWifi from "@/assets/onboarding/groundy/groundy-tile-wifi.png";
import tileOutlets from "@/assets/onboarding/groundy/groundy-tile-outlets.png";
import tileSeating from "@/assets/onboarding/groundy/groundy-tile-seating.png";
import tileParking from "@/assets/onboarding/groundy/groundy-tile-parking.png";
import location from "@/assets/onboarding/groundy/groundy-location.png";
import picks from "@/assets/onboarding/groundy/groundy-picks.png";
import waitlist from "@/assets/onboarding/groundy/groundy-waitlist.png";
import account from "@/assets/onboarding/groundy/groundy-account.png";
import aboutYou from "@/assets/onboarding/groundy/groundy-about-you.png";
import notifications from "@/assets/onboarding/groundy/groundy-notifications.png";
import finish from "@/assets/onboarding/groundy/groundy-finish.png";

export const GROUNDY = {
  welcomeBody,
  welcomeHand,
  score,
  priorities,
  tileWifi,
  tileOutlets,
  tileSeating,
  tileParking,
  location,
  picks,
  waitlist,
  account,
  aboutYou,
  notifications,
  finish,
} as const;
